import { useCallback } from 'react';
import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellString } from '../../table/cells/CellString';
import { isFunction } from 'lodash-es';

export const ModelCellArrayReferenceBase = ({
  getValue,
  accessor = 'display_name',
  ...props
}: TableInheritedProps & {
  // accessor is either an attribute name or a function deriving the label
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accessor?: string | ((value: any) => any);
}) => {
  const syntheticGetValue = useCallback(
    () =>
      getValue!()
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ?.map((v: any) =>
          isFunction(accessor) ? accessor(getValue!()) : v[accessor]
        )
        ?.join(', '),
    [accessor, getValue]
  );

  return <CellString getValue={syntheticGetValue} {...props} />;
};

export const ModelCellArrayReference = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute(
    'ModelCellArrayReference',
    ModelCellArrayReferenceBase,
    props
  );
